import { useRef } from "react";
import { useSearchStore } from "../../../store/store";
import { useTableSettingsStore } from "../../../store/tableSettings/store";
import { tableViewNames } from "../../constants/agentProductionConstants";
import { additionalTableHeaders, columns as agentCols } from "../tableSettings";
import { getSummaryPinnedConfig } from "../../../common/components/table/agGrid/pinnedRowSettings";
import { getAgentMovementTableView } from "../../../common/components/table/tableViews/agentMovement";

export const useTable = agentData => {
    const gridRef = useRef();
    const {
        defaultSort,
        columns,
        totals,
        setColumns,
    } = useTableSettingsStore(state => {
        const selectedModule = useSearchStore.getState().selectedModule;
        const totals = useSearchStore.getState()[selectedModule]?.totals;
        const moduleState = state[selectedModule];
        return ({
            defaultSort: moduleState?.defaultSort,
            columns: moduleState?.columns,
            totals,
            setColumns: state.setColumns,
        });
    });

    const summaryPinnedConfig = getSummaryPinnedConfig(tableViewNames.agentMovement);

    const tableView = getAgentMovementTableView({defaultSort});

    const tableProps = {
        key: tableView?.id,
        additionalTableHeaders,
        columns,
        setColumns,
        gridRef,
        rowData: agentData,
        tableTitleWithTooltips: agentCols,
        tableView,
        pinnedBottomRowData: [{ ...totals }],
        externalParams: {summaryPinnedConfig},
        isTableAutoHeight: false,
    };

    return  tableProps;
};
